// built-from: /attachment-validation-routing v1 impl:attachment-validation-routing role:implementation
import { sniffStructuredDoc } from './structuredDocSniff';

export interface RoutedSessionAttachments {
  structured: { file: File; text: string }[];
  regular: File[];
}

export async function partitionSessionAttachments(files: File[]): Promise<RoutedSessionAttachments> {
  const structured: { file: File; text: string }[] = [];
  const regular: File[] = [];

  for (const file of files) {
    const probe = await sniffStructuredDoc(file);
    if (probe.isStructured) {
      structured.push({ file, text: probe.text });
    } else {
      regular.push(file);
    }
  }

  return { structured, regular };
}
